<template>
<div v-if="cargada">
    <span class="font-weight-black body-2 white--text subtitulo">FOLIOS GLOSA </span><br />
    <span class="font-weight-black  caption secondary--text subtitulo">Recibidos </span>
    <v-chip x-small color="primary">
        {{total}}
    </v-chip>
     <v-btn icon color="secondary" @click="cargaGlosas" title="Actualizar" v-tippy><v-icon>mdi-refresh</v-icon> </v-btn>
    <br />
    <span class="font-weight-black  caption secondary--text subtitulo">Periodos Disponibles</span>
    <accordion v-for="item in calendario" :porcentaje="item[1]['avance']" :titulo="item[0]" :key="item.index">
        <div class="text-lg-right">
            <v-chip x-small label outlined :color="item[1]['1']=='X'?'yellow':item[1]['1']?'green':'red'" class="mes">
                Enero
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['2']=='X'?'yellow':item[1]['2']?'green':'red'" class="mes">
                Febrero
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['3']=='X'?'yellow':item[1]['3']?'green':'red'" class="mes">
                Marzo
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['4']=='X'?'yellow':item[1]['4']?'green':'red'" class="mes">
                Abril
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['5']=='X'?'yellow':item[1]['5']?'green':'red'" class="mes">
                Mayo
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['6']=='X'?'yellow':item[1]['6']?'green':'red'" class="mes">
                Junio
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['7']=='X'?'yellow':item[1]['7']?'green':'red'" class="mes">
                Julio
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['8']=='X'?'yellow':item[1]['8']?'green':'red'" class="mes">
                Agosto
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['9']=='X'?'yellow':item[1]['9']?'green':'red'" class="mes">
                Septiembre
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['10']=='X'?'yellow':item[1]['10']?'green':'red'" class="mes">
                Octubre
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['11']=='X'?'yellow':item[1]['11']?'green':'red'" class="mes">
                Noviembre
            </v-chip>
            <v-chip x-small label outlined :color="item[1]['12']=='X'?'yellow':item[1]['12']?'green':'red'" class="mes">
                Diciembre
            </v-chip>
        </div>
    </accordion>

    <span class="font-weight-black  caption secondary--text subtitulo">Actualizado </span>
    <v-chip x-small color="primary">
        {{ultima}}
    </v-chip>

</div>
</template>

<script>
import accordion from "@/components/acordion.vue";
import axios from "axios";
export default {
    components: {
        accordion
    },
    name: 'glosasCargadas',
    created() {
        this.cargaGlosas();
    },
    methods: {
        cargaGlosas: function (key) {
          
            var datos = {
                rfc: this.$local_storage.get("rfc"),
            }
            axios.post(this.$apiReportes + 'reportes/get_calendar/', datos)
                .then((response) => {
                    if (response.data.calendario) {
                        this.total = response.data.total;
                        this.ultima = (response.data.ultima!=null?response.data.ultima.substring(0, 10):"");
                        var result = Object.entries(response.data.calendario);
                        this.calendario = result.reverse();
                        this.cargada = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

    },

    data() {
        return {
            calendario: [],
            total: 0,
            ultima: "",
            cargada: false
        };
    },
};
</script>

<style scoped>
.mes {
    width: 70px;
    margin-left: 1px;
    padding-left: 4px;
}

.subtitulo {
    margin-left: 20px;
}
</style>
